import Box from '@ilg-totallymoney/ui/components/Box'
import Row from '@ilg-totallymoney/ui/components/Row'
import InfoLabel from '@ilg-totallymoney/ui/productTable/components/InfoLabel'

const CardPositivesInfo = ({ positives }: { positives: string[] }) => {
    const filteredPositives = positives.filter(Boolean)

    return filteredPositives.length > 0 ? (
        <Row space="space05" flexWrap="wrap">
            {filteredPositives.map(positive => (
                <Box key={positive} width={['100%', 'auto']}>
                    <InfoLabel text={positive} />
                </Box>
            ))}
        </Row>
    ) : null
}

export default CardPositivesInfo
